export const GET_SMS_ANALYTICS_HERO_STATS = gql`
  query GetSMSAnalyticsHeroStats($filters: SMSLogFiltersInput) {
    smsAnalyticsHeroStats(filters: $filters) {
      current {
        totalSms
        outboundSms
        inboundSms
        automatedSms
        timeSavedSeconds
      }
      previous {
        totalSms
        outboundSms
        inboundSms
        automatedSms
        timeSavedSeconds
      }
    }
  }
`

export const GET_SMS_VOLUME = gql`
  query GetSMSVolume($input: SMSVolumeInput!) {
    smsVolume(input: $input) {
      bucket
      series {
        direction
        points {
          periodStart
          count
        }
      }
    }
  }
`

export const GET_SMS_ACTIVITY_BY_EMPLOYEE = gql`
  query GetSMSActivityByEmployee($filters: SMSLogFiltersInput) {
    smsActivityByEmployee(filters: $filters) {
      total
      items {
        rowId
        rowName
        isSystemActor
        outbound
        inbound
      }
    }
  }
`
